<div
  class="cb-dialog-layout-container"
  [style.width]="width() ?? 'auto'"
  [style.height]="height() ?? '100%'"
>
  <div class="cb-dialog-layout-topbar">
    @if (icon()) {
      <div class="cb-dialog-layout-topbar-icon">
        <cb-featured-icon
          [name]="icon()!"
          [type]="iconType()"
          [color]="iconColor()"
        ></cb-featured-icon>
      </div>
    }
    <div class="cb-dialog-layout-topbar-controls">
      @let headlineControls = headlineControlsTemplate();
      @if (headlineControls) {
        <ng-container *ngTemplateOutlet="headlineControls"></ng-container>
      }
      <div class="cb-dialog-layout-topbar-close">
        <div class="cb-dialog-layout-close-button" (click)="close()">
          <cb-icon name="cb cb-base-outline-close"></cb-icon>
        </div>
      </div>
    </div>
  </div>
  <div class="cb-dialog-layout-header">
    <div class="cb-dialog-layout-title">
      <h2 [innerHTML]="title()"></h2>
      @if (subtitle() && subtitle()!.length > 0) {
        <p>{{ subtitle() }}</p>
      }
      @let subtitleTemp = subtitleTemplate();
      @if (subtitleTemp) {
        <ng-container *ngTemplateOutlet="subtitleTemp"></ng-container>
      }
    </div>
    @let titleControls = titleControlsTemplate();
    @if (titleControls) {
      <ng-container *ngTemplateOutlet="titleControls"></ng-container>
    }
  </div>
  <div class="cb-dialog-layout-content">
    @if (bodyTemplate()) {
      <ng-container *ngTemplateOutlet="bodyTemplate()!"></ng-container>
    }
  </div>
  @if (!hideControls()) {
    <div class="cb-dialog-layout-buttons" [class.cb-sticky]="stickyControls()">
      <div class="cb-dialog-layout-buttons-side">
        @if (!hideCloseButton()) {
          <cb-button
            size="md"
            color="gray"
            hierarchy="secondary"
            (click)="close()"
            >{{ "COMMON.CLOSE" | translate }}</cb-button
          >
        }
        @if (leftButtonsTemplate()) {
          <ng-container
            *ngTemplateOutlet="leftButtonsTemplate()!"
          ></ng-container>
        }
      </div>
      <div class="cb-dialog-layout-buttons-side">
        @if (rightButtonsTemplate()) {
          <ng-container
            *ngTemplateOutlet="rightButtonsTemplate()!"
          ></ng-container>
        }
      </div>
    </div>
  }
</div>
